
import React, { useState, Fragment } from 'react'
import { Route, Routes } from 'react-router-dom'
import { v4 as uuid } from 'uuid'

import AutoDismissAlert from './components/shared/AutoDismissAlert/AutoDismissAlert'
import RequireAuth from './components/shared/RequireAuth'
import Home from './components/Home'
import SignUp from './components/auth/SignUp'
import SignIn from './components/auth/SignIn'
import SignOut from './components/auth/SignOut'
import ChangePassword from './components/auth/ChangePassword'
import PetSitterIndex from './components/pet_sitter/PetSitterIndex'
import PetSitterShow from './components/pet_sitter/PetSitterShow'
import PetOwnerCreate from './components/pet_owner/PetOwnerCreate'
import PetOwnerShow from './components/pet_owner/PetOwnerShow'
import PetSitterCreate from './components/pet_sitter/PetSitterCreate'
import BookingIndex from './components/booking/BookingIndex'
import ReviewIndex from './components/reviews/ReviewIndex'
import SideNav from './components/shared/SideNav'
import Dashboard from './components/shared/Dashboard'
import Error from './components/shared/Error'

const App = () => {

	const [user, setUser] = useState(null)
	const [msgAlerts, setMsgAlerts] = useState([])

	const clearUser = () => {
		console.log('clear user ran')
		setUser(null)
	}

	const deleteAlert = (id) => {
		setMsgAlerts((prevState) => {
			return (prevState.filter((msg) => msg.id !== id))
		})
	}

	const msgAlert = ({ heading, message, variant }) => {
		const id = uuid()
		setMsgAlerts(() => {
			return (
				[{ heading, message, variant, id }]
			)
		})
	}

	return (
		<Fragment>
			<SideNav className='d-flex' user={user} />
			<Routes>
				<Route path='/' element={<Home msgAlert={msgAlert} user={user} />} />
				<Route
					path='/sign-up'
					element={<SignUp msgAlert={msgAlert} setUser={setUser} />}
				/>
				<Route
					path='/sign-in'
					element={<SignIn msgAlert={msgAlert} setUser={setUser} />}
				/>
				<Route
					path='/sign-out'
					element={
						<RequireAuth user={user}>
							<SignOut msgAlert={msgAlert} clearUser={clearUser} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/change-password'
					element={
						<RequireAuth user={user}>
							<ChangePassword msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/petsitters'
					element={

						<PetSitterIndex msgAlert={msgAlert} user={user} />
					}
				/>
				<Route
					path='/petsitters/:id'
					element={
						<PetSitterShow msgAlert={msgAlert} user={user} />
					}
				/>
				<Route
					path='/petsitters/create'
					element={
						<RequireAuth user={user}>
							<PetSitterCreate msgAlert={msgAlert} user={user} />
						</RequireAuth>}
				/>
				<Route
					path='/petowners/'
					element={
						<PetOwnerShow msgAlert={msgAlert} user={user} />
					}
				/>
				<Route
					path='/petowners/create'
					element={
						<RequireAuth user={user}>
							<PetOwnerCreate msgAlert={msgAlert} user={user} />
						</RequireAuth>}
				/>
				<Route
					path='/bookings'
					element={
						<RequireAuth user={user}>
							<BookingIndex msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/reviews'
					element={
						<RequireAuth user={user}>
							<ReviewIndex msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/dashboard'
					element={
						<RequireAuth user={user}>
							<Dashboard msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/error'
					element={
						<Error msgAlert={msgAlert} user={user} />
					}
				/>
			</Routes>
			{msgAlerts.map((msgAlert) => (
				<AutoDismissAlert
					key={msgAlert.id}
					heading={msgAlert.heading}
					variant={msgAlert.variant}
					message={msgAlert.message}
					id={msgAlert.id}
					deleteAlert={deleteAlert}
				/>
			))}
		</Fragment>
	)
}

export default App
